var map = {
	"./1_FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8436.webp": "./src/img/brands/punto-maq/1_FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8436.webp",
	"./FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8178.webp": "./src/img/brands/punto-maq/FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8178.webp",
	"./FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8210.webp": "./src/img/brands/punto-maq/FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8210.webp",
	"./FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8233.webp": "./src/img/brands/punto-maq/FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8233.webp",
	"./FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8251.webp": "./src/img/brands/punto-maq/FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8251.webp",
	"./FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8342.webp": "./src/img/brands/punto-maq/FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8342.webp",
	"./FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8347.webp": "./src/img/brands/punto-maq/FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8347.webp",
	"./FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8398.webp": "./src/img/brands/punto-maq/FeliErnst_PUNTO MAQ_Centro comercial_fotografia_MG_8398.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/punto-maq sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";